import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { useState, type ReactNode } from "react";

import { trpc } from "./trpc";

const API_BASE =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.PROD
    ? "https://vy-australia-backend.kishek12.workers.dev"
    : "");

interface TrpcProviderProps {
  children: ReactNode;
}

/**
 * Lightweight tRPC provider for the NZ marketing site.
 *
 * The NZ chapter shares the existing AU worker for contact-form
 * submissions — no separate backend stack stood up. There's no Clerk
 * here (no portal, no admin) so no Bearer header is sent; the
 * contact mutation is public.
 */
export function TrpcProvider({ children }: TrpcProviderProps) {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: `${API_BASE}/trpc`,
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
